import React, { Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { postCabinet, postDevice, getCabinetByID, getDevices, putCabinet, removeCabinet, userCanEdit, getDevice, DelDeviceOrThingRelation } from '../helpers/helper.js';
import { Component } from 'react';
import { setDeviceLink, getDeviceType } from '../helpers/helper.js';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import { IconButton, Typography, Paper, Card, CardContent, InputAdornment, useMediaQuery, Grid } from '@mui/material';
import { Alert } from '@mui/material';
import { PhotoCamera, Cancel, Add } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useTheme } from '@mui/styles';
import WebQrScanner from './WebQrScanner.jsx';

class AddCabinetFormDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            delete: false,
            coord: {
                lat: null,
                lng: null
            },
            cabinetId: null,
            serialNumber: '',
            snMacAddress: '',
            originalSerialNumber: '',
            label: '',
            activeStep: 0,
            activeCamera: false,
            resultDevice: '',
            deviceSelected: null,
            originalDeviceSelected: null,
            deviceSelectedType: null,
            deviceSelectedProfileCode: '',
            deviceSelectedProfileModel: '',
            deviceSelectedProfileUuid: '',
            buttonCreateObjectDisabled: true
        }
        // Bind
        this.handleScan = this.handleScan.bind(this);
        this.handleError = this.handleError.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.handleChangeLabel = this.handleChangeLabel.bind(this);
        this.sendData = this.sendData.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.getStepContent = this.getStepContent.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleCameraClick = this.handleCameraClick.bind(this);
        this.handleCancelSerialNumber = this.handleCancelSerialNumber.bind(this);
        this.extractSerialNumber = this.extractSerialNumber.bind(this);
        this.handleChangeSerialNumber = this.handleChangeSerialNumber.bind(this);
        this.handleChangeMacAddress = this.handleChangeMacAddress.bind(this);
        this.searchDevice = this.searchDevice.bind(this);
        this.handleInsertDevice = this.handleInsertDevice.bind(this);
        this.loadCabinetID = this.loadCabinetID.bind(this);

        // Stepper
        this.steps = [
            "scan_qr_code",
            "settings",
            "summary"
        ]
    }

    componentDidMount() {
        this.props.handleDialog(this.handleOpen);
        this.setState({
            originalSerialNumber: this.state.serialNumber,
            originalDeviceSelected: this.state.deviceSelected
        });
    }

    async loadCabinetID() {
        const cabinetId = this.state.cabinetId;
        let deviceData = null

        if (cabinetId === null) {
            return;
        }

        const cabinetData = await getCabinetByID(cabinetId)
            .then((responseCabinet) => {
                return (responseCabinet && responseCabinet.data.rows[0]) ? responseCabinet.data.rows[0] : {};
            })
            .catch((err) => {
                console.error("error", "AddCabinetFormDialog.jsx", "loadCabinetID.getCabinetByID", err);
                return {};
            });
        
        if(cabinetData.deviceuuid){
            const device = await getDevice(cabinetData.deviceuuid)
                .then((responseDevice) => {
                    for (let i = 0; i < responseDevice.data.rows.length; i++) {
                        if (responseDevice.data.rows[i].things[0].uuid === cabinetId) {        
                            deviceData = responseDevice.data.rows[i];
                            break;
                        }
                    }
                })
                .catch((err) => {
                    console.error(err)
                })
        }

            // Init always to summary
            const canEdit = userCanEdit();
            this.setState({
                cabinetId: cabinetId,
                serialNumber: (deviceData && deviceData.sn)         ? deviceData.sn         : '',
                originalSerialNumber : (deviceData && deviceData.sn)         ? deviceData.sn         : '',
                snMacAddress: (deviceData && deviceData.macaddress) ? deviceData.macaddress : '',
                label: cabinetData.name ? cabinetData.name : '',
                activeStep: canEdit ? 0 : 2,
                activeCamera: false,
                resultDevice: '',
                deviceSelected: null,
                originalDeviceSelected: this.state.deviceSelected,
                deviceSelectedProfileCode: (deviceData && deviceData.deviceprofilecode) ? deviceData.deviceprofilecode : '',
                deviceSelectedProfileModel: (deviceData && deviceData.deviceprofilemodel) ? deviceData.deviceprofilemodel : '',
                deviceSelectedProfileUuid: (deviceData && deviceData.deviceprofileuuid) ? deviceData.deviceprofileuuid : '',
                deviceSelectedType: null,
                buttonCreateObjectDisabled: false
            }, () => {
                if (deviceData && deviceData.sn) {
                    this.searchDevice(deviceData.sn, this.handleResultDevice);
                }
            });
    }

    initDialogState(cabinetId = null) {
        this.setState({
            cabinetId: cabinetId,
            serialNumber: '',
            snMacAddress: '',
            label: '',
            activeStep: 0,
            activeCamera: false,
            resultDevice: '',
            deviceSelected: null,
            originalDeviceSelected: null,
            deviceSelectedType: null,
            buttonCreateObjectDisabled: true
        }, async () => await this.loadCabinetID());
    }

    extractSerialNumber = (data) => {
        const { t } = this.props;
        let code = data.split(" ");
        // Controllo del formato del seriale
        if (code.length === 3) {
            return code[1];
        }
        else {
            return t("unknown_format");
        }
    }

    searchDevice = (sn, callback) => {     
        const { t } = this.props;
        let projectId = localStorage.getItem("currentProjectId");

        // Controllo sul tipo di device
        let deviceObj = getDeviceType(sn);     

        // Verifica preliminare se il device ha un seriale corretto per un punto luce
        if (deviceObj.code === "" || (deviceObj.code !== "" && deviceObj.devicetypeid !== 2)) {
            // Non è stato trovato un codice valido
            callback(<Alert severity="error">{t("device_sn_incompatible")}</Alert>);
            return;
        }

        this.setState({
            deviceSelectedType: deviceObj
        });

        getDevices(sn)                           
            .then((res) => {
                // Verifica se il tipo di device è compatibile con il cabinet
                if(res.data.rowCount === 0 ){
                    let devInfo = getDeviceType(sn.slice(0, 2));            
                    callback(
                        <Fragment>
                            <TextField
                                fullWidth
                                defaultValue={this.state.snMacAddress}
                                margin="dense"
                                label={t("mac_address")}
                                type="text"
                                variant="outlined"
                                onChange={this.handleChangeMacAddress}
                                style={{ marginBottom: "10px" }}
                                required
                            />
                            <Alert severity="info" style={{ marginBottom: "10px" }}>{"Device: " + devInfo.model + " Code: " + devInfo.code}</Alert>
                            <Alert severity="warning" style={{ marginBottom: "10px" }}>{t("device_not_found_in_archive")}</Alert>
                            <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                startIcon={<Add />}
                                onClick={() => {
                                    this.handleInsertDevice(
                                        {
                                            sn: this.state.serialNumber,
                                            deviceTypeId: devInfo.deviceTypeId,
                                            macAddress: this.state.snMacAddress,
                                            projectId: projectId,
                                            brokerProviderId: 1,
                                            deviceTypeInfoId: devInfo.id
                                        },
                                        this.handleResultDevice)
                                }
                                }>
                                {t("insert")}
                            </Button>
                        </Fragment>
                    );
                }

                else if (res.data.rowCount > 0) {
                    // Il device è abbinato ad un'altro progetto?
                    if (res.data.rows[0].projectuuid !== projectId) {
                        this.setState({
                            deviceSelected: null,
                            originalDeviceSelected: null
                        });
                        callback(<Alert severity="error">{t("incompatible_device")}</Alert>);
                        return;
                    }

                    let devInfo = getDeviceType(sn.slice(0, 2));          
                    callback(
                        <div>
                            <Alert severity="info">{"Device: " + devInfo.model + " Code: " + devInfo.code}</Alert>
                            <Alert severity="success">{t("device_found")}</Alert>
                        </div>
                    );
                    this.setState({
                        deviceSelected: res.data.rows[0]
                    });

                    if(!this.state.originalDeviceSelected){
                        this.setState({
                            originalDeviceSelected: res.data.rows[0]
                        });
                    }
                    
                    return;
                }
            })
            .catch((err) => {
                console.error(err);
                
                return;
            })
    }

    handleScan = (data) => {
        // Check data
        if (data) {
            // Estrae il seriale dall'immagine
            let snDevice = this.extractSerialNumber(data);

            // Imposta il valore del seriale
            this.setState({ serialNumber: snDevice });

            // Chiude la schermata della camera
            this.setState({
                activeCamera: false
            });

            // Recupera informazioni sul device
            this.searchDevice(snDevice, this.handleResultDevice);
        }
    }

    handleResultDevice = (result) => {
        this.setState({
            resultDevice: result
        })
    }

    handleInsertDevice = (model, callback) => {
        const { t } = this.props;
        postDevice(model)
            .then((res) => {
                this.setState({
                    deviceSelected: {...res.data.rows[0], 'macaddress': model.macAddress}
                });
                callback(<Alert severity="success">{t("device_insert_ok")}</Alert>);
            })
            .catch((err) => {
                console.error(err);
                this.setState({
                    deviceSelected: null
                });
                callback(<Alert severity="error">{t("device_insert_err")}</Alert>);
            })
    }

    handleError = (err) => {
        console.error(err)
    }

    handleChangeLabel = (event) => {
        this.setState({ label: event.target.value });
        //setLabel(event.target.value);
    }

    sendData = () => {
        // Creo dati payload
        let projectId = localStorage.getItem("currentProjectId");
        const bodyPayload = {
            "name": this.state.label,
            "geometry": [
                this.state.lng,
                this.state.lat
            ],
            "projectuuid": projectId
        };

        // Invia i dati
        postCabinet(bodyPayload)
            .then(res => {
                this.handleClose();

                // Se valorizzato anche il campo serialNumber
                // Controlla il formato del codice ed esegue l'abbinamento
                if (this.state.serialNumber && this.state.serialNumber !== '') {
                    // Eseguo l'abbinamento del cabinet creato con il relativo device
                    const thingentity = "cabinet"
                    setDeviceLink(this.state.deviceSelected.uuid, thingentity, res.data.rows[0].uuid)
                        .catch((err) => {
                            console.error(err);
                        });
                }

                let newBodyPayload = {
                    name: bodyPayload.name,
                    geometry: bodyPayload.geometry,
                    projectuuid: bodyPayload.projectuuid,
                    uuid: res.data.rows[0].uuid
                }

                // Inserire il marker nella mappa
                this.props.handleAddCabinet(newBodyPayload);
            });
    }

    sendEditData = () => {
        const bodyPayload = {
            "name": this.state.label,
            "geometry": [
                this.state.lng,
                this.state.lat
            ]
        };
    
        putCabinet(this.state.cabinetId, bodyPayload)
            .then(res => {
                this.handleClose();
                this.handleSerialNumberUpdate(res.data.rows[0].uuid);
                this.updateCabinetMarker(bodyPayload, res.data.rows[0].uuid);
            })
            .catch(err => {
                console.error(err);
            });
    }
    
    handleSerialNumberUpdate = async (cabinetUuid) => {
        if (this.state.originalSerialNumber && (this.state.serialNumber === "" || this.state.serialNumber === null || this.state.originalSerialNumber !== this.state.serialNumber ) ) {
            // Elimina la relation if originalSerialNumber esiste e new sn e empty
            await this.removeDeviceRelation(this.state.originalDeviceSelected.uuid, this.state.cabinetId) 
                .then(() => {
                })
                .catch(err => {
                    console.error(err);
                });
        } 
        
        if(this.state.serialNumber && this.state.serialNumber !== this.state.originalSerialNumber) {
            // Linka il nuovo SN se esiste e se è diverso dal originale 
            this.linkNewSerialNumber(cabinetUuid);
        }
    }
    
    removeDeviceRelation = (deviceUuid, cabinetId) => {
        return DelDeviceOrThingRelation(deviceUuid, cabinetId)
            .then(delRes => {
            })
            .catch(err => {
                console.error(err);
                throw err; 
            });
    }
    
    linkNewSerialNumber = (cabinetUuid) => {
        if (this.state.serialNumber && this.state.serialNumber !== '') {
            setDeviceLink(this.state.deviceSelected.uuid, "cabinet", cabinetUuid)
                .then(linkRes => {
                })
                .catch(err => {
                    console.error(err);
                });
        }
    }
    
    updateCabinetMarker = (bodyPayload, uuid) => {
        let newBodyPayload = {
            name: bodyPayload.name,
            geometry: bodyPayload.geometry,
            uuid: uuid
        };
    
        this.props.handlePutCabinet(newBodyPayload);
    }
    


    /**
     * Gestore per la rimozione di un cabinato
     * @param {*} newLightPoint
     */
    async sendRemoveData() {

        if (this.state.serialNumber && this.state.serialNumber !== '') {
            await DelDeviceOrThingRelation(this.state.deviceSelected.uuid, this.state.cabinetId)  
                .catch((err) => {
                    console.error(err);
                });
        }

        await removeCabinet(this.state.cabinetId)
            .then(res => {
                this.handleClose();
                // Inserire il marker nella mappa
                this.props.handleDelCabinet({ ...res.data.rows[0], uuid: this.state.cabinetId });
            })
            .catch((err) => {
                console.error(err)
            })
    }

    handleClose = () => {
        this.setState({ open: false });
        //setOpen(false);
    };

    handleOpen = (entity) => {
        this.setState({ open: true, lat: entity.lat, lng: entity.lng })
        this.initDialogState(entity.cabinetId);
    }

    handleCameraClick = () => {
        this.setState({
            activeCamera: !this.state.activeCamera
        });
    }

    handleCancelSerialNumber = () => {
        this.setState({
            serialNumber: '',
            deviceSelected: null
        });
        this.handleResultDevice('');
    }

    handleChangeSerialNumber = (event) => {
        const inputValue = event.target.value.toUpperCase()
        const isValid = /^[A-Za-z]{2}[0-9]{6}$/.test(inputValue);

        if (inputValue === "" || inputValue === null ){
            this.setState({
                serialNumber: '',
                deviceSelected: null
            });
        }

        if (isValid) {                         //Se il formatto è valido setta il SN nello state e fa la GET per cercare il device
            this.setState({ serialNumber: inputValue });
            this.searchDevice(inputValue, this.handleResultDevice);
        } else {                               //Se non è valido, non aggiorna lo stato e pulisce il result del device
            this.setState({ serialNumber: inputValue });
            this.handleResultDevice('');
            this.setState({ deviceSelectedType: null });
        }
    }

    handleChangeMacAddress = (event) => {
        this.setState({ snMacAddress: event.target.value });
    }

    getStepContent = (step) => {
        const { t } = this.props;
        const canEdit = userCanEdit();

        switch (step) {
            case 0:
                return (
                    <Paper sx={{ padding: "10px" }}>
                        <TextField
                            fullWidth
                            disabled={!canEdit}
                            value={this.state.serialNumber}
                            margin="dense"
                            id="snDevice"
                            label={t("serial_number")}
                            type="text"
                            variant="outlined"
                            inputProps={{
                                maxLength: 8
                            }}
                            onChange={this.handleChangeSerialNumber}
                            InputProps={{
                                endAdornment: canEdit ? (
                                    <InputAdornment position="end">
                                        <IconButton onClick={this.handleCameraClick}>
                                            <PhotoCamera></PhotoCamera>
                                        </IconButton>
                                        <IconButton onClick={this.handleCancelSerialNumber}>
                                            <Cancel />
                                        </IconButton>
                                    </InputAdornment>
                                ) : null
                            }}
                        />
                        {this.state.activeCamera === true ?
                            <div style={{
                                width: 'calc(100% - 2px)',
                                height: '300px',
                                maxHeight: '300px',
                                border: "1px solid #ccc",
                                borderRadius: "4px"
                            }}>
                                <WebQrScanner
                                    onError={this.handleError}
                                    onResult={this.handleScan}
                                />
                            </div> : null
                        }
                        {this.state.resultDevice}
                    </Paper>
                );
            case 1:
                return (
                    <Paper sx={{ padding: "10px" }}>
                        <TextField
                            disabled={!canEdit}
                            value={this.state.label}
                            margin="dense"
                            id="label"
                            label={t("cabinet_label")}
                            type="text"
                            fullWidth
                            onChange={this.handleChangeLabel}
                            variant="outlined"
                        />
                    </Paper>
                );
            case 2:
                return (
                    <Card>
                        <CardContent>
                            <Typography color="textSecondary" gutterBottom>Cabinet</Typography>
                            <Typography variant="h5" component="h2">{this.state.label}</Typography>
                            <Typography color="textSecondary">{t("device")}: {(this.state.deviceSelectedType !== null) ? this.state.deviceSelectedType.model : t("not_paired")}</Typography>
                            <Typography color="textSecondary">{t("code")}: {(this.state.deviceSelectedType !== null) ? this.state.deviceSelectedType.code : t("not_paired")}</Typography>
                            <Typography color="textSecondary">{t("serial_number")}: {(this.state.deviceSelected !== null) ? this.state.serialNumber : t("not_paired")}</Typography>
                            <Typography color="textSecondary">{t("mac_address")}: {(this.state.deviceSelected !== null) ? this.state.deviceSelected.macaddress : t("not_paired")}</Typography>
                        </CardContent>
                    </Card>
                );
            default:
                return 'Unknow step';
        }
    }

    handleNext = () => {
        let nextStep = this.state.activeStep + 1;
        this.setState({
            activeStep: nextStep
        });
        // Sono all'ultimo step?
        if (nextStep === this.steps.length - 1) {
            this.setState({
                buttonCreateObjectDisabled: false
            });
        }
    }

    handleBack = () => {
        this.setState({
            activeStep: this.state.activeStep - 1
        });
        this.setState({
            buttonCreateObjectDisabled: true
        });
    }

    render() {
        const { t } = this.props;
        const isEdit = (this.state.cabinetId !== null);
        const canEdit = userCanEdit();

        return (
            <Dialog
                fullScreen={this.props.isDesktop}
                open={this.state.open}
                onClose={this.handleClose}
                aria-labelledby="form-dialog-title">{
                canEdit && isEdit && this.state.delete ? (
                    <Fragment>
                        <DialogTitle id="form-dialog-title">{t("remove_cabinet")}</DialogTitle>
                        <DialogContent>
                            <div style={{ textAlign: "center", padding: "40px 10%" }}>
                                <WarningAmberIcon sx={{ fontSize: "3em" }} />
                                <Typography variant="h6">
                                    {t("remove_msg_alert")}
                                </Typography>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Grid container spacing={2} columns={2}>
                                <Grid item xs={1} style={{ textAlign: "left" }}>
                                    <span>&nbsp;</span>
                                </Grid>
                                <Grid item xs={1} style={{ textAlign: "right" }}>
                                    <Button onClick={() => this.setState({ delete: false })}>
                                        {t("cancel")}
                                    </Button>
                                    <Button onClick={() => this.sendRemoveData()}>
                                        {t("delete")}
                                    </Button>
                                </Grid>
                            </Grid>
                        </DialogActions>
                    </Fragment>
                ) : (
                    <Fragment>
                        <DialogTitle id="form-dialog-title">{
                            canEdit ? (
                                isEdit ?
                                    t("edit_cabinet") :
                                    t("add_cabinet")
                            ) : t("details_cabinet")
                        }</DialogTitle>
                        <DialogContent>
                            <Stepper
                                activeStep={this.state.activeStep}
                                orientation="vertical"
                                sx={{
                                    minWidth: {
                                        xs: '100%',
                                        sm: '100%',
                                        md: '480px',
                                        lg: '480px',
                                        xl: '480px'
                                    }
                                }}>
                                {this.steps.map((label, index) => (
                                    <Step key={label}>
                                        <StepLabel>{t(label)}</StepLabel>
                                        <StepContent>
                                            <div>{this.getStepContent(index)}</div>
                                            <div>
                                                <div style={{ marginTop: "10px" }}>
                                                    <Button disabled={this.state.activeStep === 0} onClick={this.handleBack}>
                                                        {t("back")}
                                                    </Button>
                                                    {
                                                        (this.state.activeStep < this.steps.length - 1) ?
                                                            <Button onClick={this.handleNext}>{t("next")}</Button> : ''
                                                    }
                                                </div>
                                            </div>
                                        </StepContent>
                                    </Step>
                                ))}
                            </Stepper>
                        </DialogContent>
                        <DialogActions>
                            <Grid container spacing={2} columns={2}>
                                <Grid item xs={1} style={{ textAlign: "left" }}>
                                    {canEdit && isEdit ?
                                        <Button color="error" onClick={() => this.setState({ delete: true })} startIcon={<DeleteIcon />}>
                                            {t("delete")}
                                        </Button>
                                    : <span>&nbsp;</span>}
                                </Grid>
                                <Grid item xs={1} style={{ textAlign: "right" }}>
                                    {canEdit ? (
                                        <Fragment>
                                            <Button onClick={this.handleClose}>
                                                {t("cancel")}
                                            </Button>
                                            <Button
                                                disabled={this.state.buttonCreateObjectDisabled}
                                                onClick={() => isEdit ? this.sendEditData() : this.sendData()} >
                                                {t("confirm")}
                                            </Button>
                                        </Fragment>
                                    ) : (
                                        <Button onClick={this.handleClose}>
                                            {t("Close")}
                                        </Button>
                                    )}
                                </Grid>
                            </Grid>
                        </DialogActions>
                    </Fragment>
                )
            }</Dialog>
        );
    }
}

function AddCabinetForm(props) {
    // Get flag desktop
    const isDesktop = useMediaQuery(useTheme().breakpoints.down('md'));
    // Inject media query + i18n
    return (
        <AddCabinetFormDialog
            {...props}
            isDesktop={isDesktop}
        />
    );
}

export default withTranslation()(AddCabinetForm);
